var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { usePrevious } from '@core/hooks/usePrevious';
import resizeThumbnailUrl from '@embed/components/helpers/resizeThumbnailUrl';
import { THUMBNAIL_SIZE_LARGE } from '@embed/styled';
import { ThumbnailBlurhash } from './ThumbnailBlurhash';
const ThumbnailPicture = (props) => {
    const { src, options = {}, blurhash, children, alt } = props, rest = __rest(props, ["src", "options", "blurhash", "children", "alt"]);
    const regularSize = (options === null || options === void 0 ? void 0 : options.size) || THUMBNAIL_SIZE_LARGE;
    const doubleSize = ((options === null || options === void 0 ? void 0 : options.size) || THUMBNAIL_SIZE_LARGE).map((s) => s * 2);
    const retinaWebpSrc = resizeThumbnailUrl(src, Object.assign(Object.assign({}, options), { format: 'webp', size: doubleSize }));
    const regularWebpSrc = resizeThumbnailUrl(src, Object.assign(Object.assign({}, options), { format: 'webp', size: regularSize }));
    const defaultSrc = resizeThumbnailUrl(src, Object.assign(Object.assign({}, options), { format: 'jpg', size: regularSize }));
    // Note:
    // We need to use `srcPrevious` to achieve single render
    // cycle without src (unmount) between swapping images
    // to get the browser abort previous image otherwise it will
    // appear for a brief moment within next video.
    const srcPrevious = usePrevious(src);
    return (!srcPrevious && src) || (src && src === srcPrevious) ? (<>
      <ThumbnailBlurhash blurhash={blurhash}/>
      <picture>
        <source srcSet={`${regularWebpSrc} 1x, ${retinaWebpSrc} 2x`} type="image/webp"/>
        {children ? (children({ src: defaultSrc })) : (<img src={defaultSrc} {...rest} alt={alt}/>)}
      </picture>
    </>) : null;
};
export default ThumbnailPicture;
